export const FocusGroupIcon = ({ color, width = 24, height = 24 }: any) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 16.5846V10.168M12 10.168L14.75 12.918M12 10.168L9.25 12.918"
      stroke={color}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M15.6666 7.41797H8.33325" stroke={color} stroke-linecap="round" />
    <path
      d="M2.83325 12.0007C2.83325 7.67948 2.83325 5.5189 4.17525 4.17598C5.51909 2.83398 7.67875 2.83398 11.9999 2.83398C16.3211 2.83398 18.4817 2.83398 19.8237 4.17598C21.1666 5.51982 21.1666 7.67948 21.1666 12.0007C21.1666 16.3218 21.1666 18.4824 19.8237 19.8244C18.4826 21.1673 16.3211 21.1673 11.9999 21.1673C7.67875 21.1673 5.51817 21.1673 4.17525 19.8244C2.83325 18.4833 2.83325 16.3218 2.83325 12.0007Z"
      stroke={color}
    />
  </svg>
);

export const CreateStudyIcon = ({ color, width = 24, height = 24 }: any) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6099_1662)">
      <path
        d="M3.64282 20.3574H17.7857"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3571 15.8565L7.5 16.5508L8.14286 12.6422L16.7957 4.01508C16.9152 3.89457 17.0574 3.79892 17.2141 3.73365C17.3708 3.66837 17.5388 3.63477 17.7086 3.63477C17.8783 3.63477 18.0463 3.66837 18.203 3.73365C18.3597 3.79892 18.5019 3.89457 18.6214 4.01508L19.9843 5.37793C20.1048 5.49746 20.2004 5.63966 20.2657 5.79634C20.331 5.95301 20.3646 6.12106 20.3646 6.29079C20.3646 6.46052 20.331 6.62857 20.2657 6.78525C20.2004 6.94192 20.1048 7.08412 19.9843 7.20365L11.3571 15.8565Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6099_1662">
        <rect width="18" height="18" fill="white" transform="translate(3 3)" />
      </clipPath>
    </defs>
  </svg>
);

export const ConsumerDiaryIcon = ({ color, width = 24, height = 24 }: any) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.6507 2.80078H6.7777C6.12939 2.80078 5.50764 3.06038 5.04921 3.52247C4.59079 3.98456 4.33325 4.61129 4.33325 5.26478V20.0488C4.33325 20.1421 4.37004 20.2317 4.43553 20.2977C4.50102 20.3637 4.58984 20.4008 4.68246 20.4008H17.2539C17.3465 20.4008 17.4353 20.3637 17.5008 20.2977C17.5663 20.2317 17.6031 20.1421 17.6031 20.0488C17.6031 19.9554 17.5663 19.8659 17.5008 19.7999C17.4353 19.7339 17.3465 19.6968 17.2539 19.6968H5.03166V19.3448C5.03166 18.878 5.21562 18.4303 5.54307 18.1003C5.87051 17.7702 6.31462 17.5848 6.7777 17.5848H18.6507C18.7433 17.5848 18.8321 17.5477 18.8976 17.4817C18.9631 17.4157 18.9999 17.3261 18.9999 17.2328V3.15278C18.9999 3.05943 18.9631 2.96989 18.8976 2.90388C18.8321 2.83787 18.7433 2.80078 18.6507 2.80078ZM18.3015 16.8808H6.7777C6.45235 16.8807 6.13026 16.9462 5.8304 17.0734C5.53054 17.2007 5.25897 17.3871 5.03166 17.6217V5.26478C5.03166 4.798 5.21562 4.35034 5.54307 4.02027C5.87051 3.69021 6.31462 3.50478 6.7777 3.50478H18.3015V16.8808Z"
      fill={color}
    />
    <g clip-path="url(#clip0_6099_1673)">
      <path
        d="M14.9225 10.1068L9.96978 7.07705C9.88628 7.02591 9.79064 6.998 9.69275 6.99619C9.59485 6.99438 9.49825 7.01873 9.41291 7.06673C9.32839 7.11399 9.25798 7.18291 9.20892 7.26641C9.15986 7.3499 9.13393 7.44495 9.13379 7.54179V13.6007C9.13443 13.7459 9.19272 13.885 9.29585 13.9873C9.39899 14.0896 9.53852 14.1467 9.68378 14.1462C9.78517 14.1462 9.88459 14.1182 9.97116 14.0654L14.9225 11.0356C15.0021 10.9871 15.0678 10.919 15.1135 10.8377C15.1591 10.7564 15.1831 10.6648 15.1831 10.5716C15.1831 10.4784 15.1591 10.3867 15.1135 10.3055C15.0678 10.2242 15.0021 10.156 14.9225 10.1075V10.1068ZM9.68378 13.5941V7.54626L14.6279 10.5712L9.68378 13.5941Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_6099_1673">
        <rect
          width="8.79991"
          height="8.79991"
          fill="white"
          transform="translate(7.56006 5.78906)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ProductTestingIcon = ({ color, width = 24, height = 24 }: any) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.75 5.25097H21V6.37597H9.75V5.25097ZM9.75 12.001V10.876H21V12.001H9.75ZM9.75 17.626V16.501H21V17.626H9.75ZM5.25 9.75097C5.56054 9.75097 5.85059 9.80959 6.12012 9.92676C6.38965 10.0439 6.62988 10.2051 6.84082 10.4102C7.05176 10.6153 7.21289 10.8525 7.32422 11.1221C7.43555 11.3916 7.49414 11.6846 7.5 12.001C7.5 12.3115 7.4414 12.6016 7.32422 12.8711C7.20703 13.1406 7.0459 13.3808 6.84082 13.5918C6.63574 13.8027 6.39844 13.9639 6.12891 14.0752C5.85937 14.1865 5.56641 14.2451 5.25 14.251C4.93946 14.251 4.64941 14.1924 4.37988 14.0752C4.11035 13.958 3.87012 13.7969 3.65918 13.5918C3.44824 13.3867 3.28711 13.1494 3.17578 12.8799C3.06445 12.6103 3.00586 12.3174 3 12.001C3 11.6904 3.05859 11.4004 3.17578 11.1308C3.29297 10.8613 3.4541 10.6211 3.65918 10.4102C3.86426 10.1992 4.10156 10.0381 4.37109 9.92676C4.64063 9.81544 4.93359 9.75682 5.25 9.75097ZM5.25 13.2666C5.42578 13.2666 5.58985 13.2344 5.74219 13.1699C5.89453 13.1054 6.02637 13.0147 6.13769 12.8975C6.24902 12.7803 6.33984 12.6455 6.41016 12.4932C6.48047 12.3408 6.51562 12.1768 6.51562 12.001C6.51562 11.8252 6.4834 11.6611 6.41894 11.5088C6.35449 11.3565 6.26367 11.2246 6.14648 11.1133C6.0293 11.002 5.89453 10.9111 5.74219 10.8408C5.58985 10.7705 5.42578 10.7353 5.25 10.7353C5.07422 10.7353 4.91015 10.7676 4.75781 10.832C4.60547 10.8965 4.47363 10.9873 4.36231 11.1045C4.25098 11.2217 4.16016 11.3565 4.08984 11.5088C4.01953 11.6611 3.98438 11.8252 3.98438 12.001C3.98438 12.1768 4.0166 12.3408 4.08106 12.4932C4.14551 12.6455 4.23633 12.7773 4.35352 12.8887C4.4707 13 4.60547 13.0908 4.75781 13.1611C4.91015 13.2314 5.07422 13.2666 5.25 13.2666ZM5.25 15.376C5.56054 15.376 5.85059 15.4346 6.12012 15.5518C6.38965 15.6689 6.62988 15.8301 6.84082 16.0352C7.05176 16.2403 7.21289 16.4775 7.32422 16.7471C7.43555 17.0166 7.49414 17.3096 7.5 17.626C7.5 17.9365 7.4414 18.2266 7.32422 18.4961C7.20703 18.7656 7.0459 19.0058 6.84082 19.2168C6.63574 19.4277 6.39844 19.5889 6.12891 19.7002C5.85937 19.8115 5.56641 19.8701 5.25 19.876C4.93946 19.876 4.64941 19.8174 4.37988 19.7002C4.11035 19.583 3.87012 19.4219 3.65918 19.2168C3.44824 19.0117 3.28711 18.7744 3.17578 18.5049C3.06445 18.2353 3.00586 17.9424 3 17.626C3 17.3154 3.05859 17.0254 3.17578 16.7558C3.29297 16.4863 3.4541 16.2461 3.65918 16.0352C3.86426 15.8242 4.10156 15.6631 4.37109 15.5518C4.64063 15.4404 4.93359 15.3818 5.25 15.376ZM5.25 18.8916C5.42578 18.8916 5.58985 18.8594 5.74219 18.7949C5.89453 18.7304 6.02637 18.6397 6.13769 18.5225C6.24902 18.4053 6.33984 18.2705 6.41016 18.1182C6.48047 17.9658 6.51562 17.8018 6.51562 17.626C6.51562 17.4502 6.4834 17.2861 6.41894 17.1338C6.35449 16.9815 6.26367 16.8496 6.14648 16.7383C6.0293 16.627 5.89453 16.5361 5.74219 16.4658C5.58985 16.3955 5.42578 16.3603 5.25 16.3603C5.07422 16.3603 4.91015 16.3926 4.75781 16.457C4.60547 16.5215 4.47363 16.6123 4.36231 16.7295C4.25098 16.8467 4.16016 16.9815 4.08984 17.1338C4.01953 17.2861 3.98438 17.4502 3.98438 17.626C3.98438 17.8018 4.0166 17.9658 4.08106 18.1182C4.14551 18.2705 4.23633 18.4023 4.35352 18.5137C4.4707 18.625 4.60547 18.7158 4.75781 18.7861C4.91015 18.8564 5.07422 18.8916 5.25 18.8916ZM4.6875 6.14746L7.10449 3.73047L7.89551 4.52148L4.6875 7.72949L3.16699 6.20898L3.958 5.41797L4.6875 6.14746Z"
      fill={color}
    />
  </svg>
);

export const ImportResearchIcon = ({ color, width = 48, height = 24 }: any) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.875 4.66667C8.875 4.16021 9.24442 3.75 9.7 3.75H20.425C20.8806 3.75 21.25 4.16021 21.25 4.66667V19.3333C21.25 19.8398 20.8806 20.25 20.425 20.25H9.7C9.24442 20.25 8.875 19.8398 8.875 19.3333V16.5833H5.575C5.11942 16.5833 4.75 16.1731 4.75 15.6667V8.33333C4.75 7.82688 5.11942 7.41667 5.575 7.41667H8.875V4.66667ZM14.8333 7.41667V4.66667H9.79167V7.41667H14.8333ZM15.75 4.66667V7.41667H20.3333V4.66667H15.75ZM14.8333 8.33333H13V11.5417H14.8333V8.33333ZM15.75 11.5417V8.33333H20.3333V11.5417H15.75ZM14.8333 12.4583H13V15.6667H14.8333V12.4583ZM15.75 15.6667V12.4583H20.3333V15.6667H15.75ZM14.8333 16.5833H9.79167V19.3333H14.8333V16.5833ZM15.75 19.3333V16.5833H20.3333V19.3333H15.75ZM12.0833 8.33333V15.6667H5.575V8.33333H12.0833ZM7.14525 9.70833H8.12929L8.92817 11.4289L9.77196 9.70833H10.6914L9.425 12L10.7207 14.2917H9.75042L8.88004 12.4904L8.01379 14.2917H7.02929L8.34654 11.9918L7.14525 9.70833Z"
      fill={color}
    />
    <path
      d="M42.3529 4.5918H29.647C28.0876 4.5918 26.8235 5.91836 26.8235 7.55476V16.4436C26.8235 18.08 28.0876 19.4066 29.647 19.4066H42.3529C43.9123 19.4066 45.1764 18.08 45.1764 16.4436V7.55476C45.1764 5.91836 43.9123 4.5918 42.3529 4.5918Z"
      stroke={color}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M33.614 15.4361V9.21392C33.6111 9.10887 33.6355 9.00497 33.6846 8.91339C33.7338 8.82182 33.8058 8.74605 33.8929 8.69424C33.98 8.64243 34.079 8.61653 34.1791 8.61935C34.2792 8.62216 34.3767 8.65358 34.4611 8.71021L39.5434 11.8213C39.6283 11.8736 39.6988 11.9483 39.7477 12.0379C39.7966 12.1276 39.8224 12.2291 39.8224 12.3324C39.8224 12.4358 39.7966 12.5373 39.7477 12.6269C39.6988 12.7166 39.6283 12.7913 39.5434 12.8435L34.4611 15.9547C34.3748 16.0069 34.277 16.0343 34.1774 16.0341C34.0779 16.0338 33.9801 16.006 33.8942 15.9533C33.8082 15.9007 33.7369 15.8251 33.6878 15.7343C33.6386 15.6435 33.6131 15.5406 33.614 15.4361V15.4361Z"
      stroke={color}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
